import {
  formatEstimatedPageRange,
  REPORT_PAGE_ESTIMATE_PROGRESS_REFERENCE_PAGES,
  ReportPageEstimateResult,
} from '../reportPageEstimate';
import { InspectionPageEstimateInput } from './buildInspectionPageEstimateInput';
import { buildInspectionReportBlocks } from './layout/buildInspectionReportBlocks';
import { countPdfPages } from './layout/pdf/pdfBlocks';

export function estimateInspectionPages(
  input: InspectionPageEstimateInput
): ReportPageEstimateResult {
  const pages = Math.max(1, countPdfPages(buildInspectionReportBlocks(input)));
  const progressReference = REPORT_PAGE_ESTIMATE_PROGRESS_REFERENCE_PAGES;

  return {
    pages,
    progressPercent: Math.min(
      100,
      Math.round((pages / progressReference) * 100)
    ),
  };
}

export { formatEstimatedPageRange };
